import users from './index.js';

const SET_ADMIN_USERS = (state, fetchedAdminUsers) => {
  state.users = fetchedAdminUsers;
  state.adminUsersOutDated=false;
};


const INVALIDATE = (state) => {
  state.adminUsersOutDated=true;
}

export default {
  SET_ADMIN_USERS,
  INVALIDATE
};
